import { useAuth0 } from '@auth0/auth0-react';
import { useParams } from 'react-router';
import useSWRMutation from 'swr/mutation';
import { GeocodeRequest } from './DTO/GeocodeRequest';
import useAISearchProgress from './useAISearchProgress';
import { LanguageProficiency, SearchPeriod, useSearchFilters } from './useSearchFilters';
import http from '@/Utils/HTTP/NewHttpUtils';

export interface UpdateSearchParametersFilterRequest {
    jobTitleSearchPeriod: SearchPeriod;
    jobTitles: string[];
    companiesSearchPeriod: SearchPeriod;
    companies: string[];
    locationRadius: number;
    locations: GeocodeRequest[];
    keywords: string[];
    minYearsOfExperience: number;
    maxYearsOfExperience: number;
    includeEmptyExperience: boolean;
    languages: string[];
    languageProficiency: LanguageProficiency;
}

export const useUpdateSearchParametersFilter = () => {
    const { getAccessTokenSilently } = useAuth0();
    const { assessmentId } = useParams();
    const { mutate: mutateSearchFilter } = useSearchFilters(assessmentId!);
    const { mutate: mutateAiSearchProgress } = useAISearchProgress();

    return useSWRMutation(
        `recruitments/${assessmentId}/ai-search/search-parameters`,
        async (path: string, { arg }: { arg: UpdateSearchParametersFilterRequest }) => {
            await http.put({
                path,
                accessToken: await getAccessTokenSilently(),
                body: arg,
            });
        },
        {
            onSuccess: async () => {
                // When filters are updated, then we need to refetch the following data:
                // 1. search filters
                // 2. search progress status
                // 3. identified profiles will be refetch automatically when search progress status is false
                await Promise.all([mutateAiSearchProgress(), mutateSearchFilter()]);
            },
        },
    );
};
